import { createSlice } from '@reduxjs/toolkit';
import { createregistrationRequest } from './courseRegistrationService';

const initialState = {
  registrationRequestCreate: {
    isDataLoading: null,
    isDataLoaded: null,
    message: null,
    registrationRequest: null,
    success: null,
  },
};

const courseRegistration = createSlice({
  name: 'courseRegistration',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // PENDING
    builder.addCase(createregistrationRequest.pending, (state) => {
      state.registrationRequestCreate = {
        ...initialState.registrationRequestCreate,
        isDataLoading: true,
        isDataLoaded: false,
        message: 'Loading',
        success: null,
      };
    });

    builder.addCase(createregistrationRequest.rejected, (state, action) => {
      state.registrationRequestCreate = {
        ...initialState.registrationRequestCreate,
        isDataLoading: false,
        isDataLoaded: false,
        message: action.payload || 'Error occurred while creating the registrationRequest',
        success: false,
      };
    });

    builder.addCase(createregistrationRequest.fulfilled, (state, action) => {
      state.registrationRequestCreate = {
        ...initialState.registrationRequestCreate,
        isDataLoading: false,
        isDataLoaded: true,
        message: 'registrationRequest creation is successful',
        registrationRequest: action.payload.order,
        success: true,
      };
    });
  },
});

export default courseRegistration.reducer;